module.exports = __webpack_public_path__ + "img/log.14e3d0f3.png";